<template>
  <v-card width="100vw">
    <Parallax
      src="https://images.unsplash.com/photo-1572851899307-3c130a64e831?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1050&q=80"
      height="225"
      width="100vw"
    >
      <v-row justify="center" align="center">
        <v-col cols="auto">
          <div>
            <p
              class="banner-text text-center font-weight-bold text-uppercase text-sm-body-1"
              v-for="(n, i) in appNameSplitted"
              :key="i"
            >
              <span class=" text--disabled ">&lt;</span> {{ n }}
              <span class=" text--disabled ">&gt;</span>
            </p>
          </div>
        </v-col>
      </v-row>
    </Parallax>
  </v-card>
</template>
<script>
import Parallax from "./base/Parallax";
export default {
  name: "Banner",
  components: {
    Parallax,
  },
  computed: {
    appName() {
      return this.$store.getters["settings/appName"];
    },
    appNameSplitted() {
      const arr = this.appName.split(" ");
      return arr;
    },
  },
};
</script>
